"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_icons_1 = require("@carvana/helios-icons");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var TextInput_styles_1 = require("./TextInput.styles");
var TextInput = function (_a) {
    var children = _a.children, className = _a.className, disabled = _a.disabled, error = _a.error, _b = _a.hasError, hasError = _b === void 0 ? false : _b, id = _a.id, _c = _a.value, value = _c === void 0 ? '' : _c, inputRef = _a.inputRef, label = _a.label, maxLength = _a.maxLength, minLength = _a.minLength, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, testId = _a.testId, _d = _a.touched, touched = _d === void 0 ? false : _d, _e = _a.width, width = _e === void 0 ? '280px' : _e, _f = _a.type, type = _f === void 0 ? 'text' : _f, inputMode = _a.inputMode, _g = _a.maskInputValue, maskInputValue = _g === void 0 ? false : _g, mask = _a.mask, restProps = __rest(_a, ["children", "className", "disabled", "error", "hasError", "id", "value", "inputRef", "label", "maxLength", "minLength", "onBlur", "onChange", "onFocus", "testId", "touched", "width", "type", "inputMode", "maskInputValue", "mask"]);
    var _h = (0, react_1.useState)(false), touchedState = _h[0], setTouchedState = _h[1];
    var _j = (0, react_1.useState)(null), cursor = _j[0], setCursor = _j[1];
    var ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var input = inputRef ? inputRef.current : ref.current;
        if (input && typeof input.setSelectionRange === 'function')
            input.setSelectionRange(cursor, cursor);
    }, [inputRef, cursor, value]);
    var hasBeenTouched = touchedState || touched;
    var hasValue = !!value;
    var validMinLength = minLength ? (value === null || value === void 0 ? void 0 : value.length) >= minLength : true;
    var validMaxLength = maxLength ? (value === null || value === void 0 ? void 0 : value.length) <= maxLength : true;
    var isValid = !error && hasBeenTouched && hasValue && validMinLength && validMaxLength;
    var shouldShowError = hasError || error;
    var handleInputBlur = function (e) {
        if (onBlur)
            onBlur(e);
        setTouchedState(true);
    };
    var handleInputChange = function (e) {
        setCursor(e.target.selectionStart);
        if (onChange)
            onChange(e);
    };
    var handleInputFocus = function (e) {
        if (onFocus)
            onFocus(e);
    };
    var inputProps = __assign({ id: id, value: value, onBlur: handleInputBlur, onChange: handleInputChange, onFocus: handleInputFocus, label: label, maxLength: maxLength, minLength: minLength, inputMode: inputMode }, restProps);
    var classNames = (0, classnames_1.default)(shouldShowError && 'show-error-icon', hasValue && 'is-populated', disabled && 'is-disabled', (label === null || label === void 0 ? void 0 : label.length) && 'has-label', maskInputValue && 'fs-mask');
    return ((0, jsx_runtime_1.jsxs)(TextInput_styles_1.InputWrapper, __assign({ className: (0, classnames_1.default)(classNames, className), width: width, "data-testid": testId }, { children: [(0, jsx_runtime_1.jsxs)(TextInput_styles_1.InputContainer, { children: [mask ? ((0, jsx_runtime_1.jsx)(TextInput_styles_1.StyledInputMask, __assign({ disabled: disabled, type: type, className: classNames, ref: inputRef || ref, mask: mask }, inputProps))) : ((0, jsx_runtime_1.jsx)(TextInput_styles_1.StyledInput, __assign({ disabled: disabled, type: type, className: classNames, ref: inputRef || ref }, inputProps))), (0, jsx_runtime_1.jsx)(TextInput_styles_1.Label, __assign({ htmlFor: id }, { children: label })), isValid && hasValue && ((0, jsx_runtime_1.jsx)(TextInput_styles_1.IconContainer, { children: (0, jsx_runtime_1.jsx)(helios_icons_1.CheckmarkCircle, { width: 16, height: 16 }) })), shouldShowError && ((0, jsx_runtime_1.jsx)(TextInput_styles_1.IconContainer, { children: (0, jsx_runtime_1.jsx)(helios_icons_1.ExclamationCircle, {}) })), children] }), shouldShowError && error && (0, jsx_runtime_1.jsx)(TextInput_styles_1.ErrorTextContainer, { children: error })] })));
};
exports.default = TextInput;
